/* globals adstackData, headerBiddingData, googletag, hmUtils, pbjs */
let hashedNPI;
( function () {
	let NPIFromLS = window.localStorage.getItem( 'hmi' );
	const parsedHMI = NPIFromLS ? JSON.parse( NPIFromLS ) : '';
	if ( parsedHMI ) {
		hashedNPI =  parsedHMI && parsedHMI.npiFullHash;
	}
} )();
/**
 * Get ad slot path
 * @returns {string|string}
 */
function dfpAdSlotPath() {
	return typeof adstackData !== 'undefined' && adstackData ?
		adstackData.dfp_network_code + '/' + adstackData.dfp_ad_path + '/' : '';
}
/**
 * Check if its mobile
 * @returns {boolean}
 */
function isMobile() {
	return Math.min( window.screen.width, window.screen.height ) < 640 || navigator.userAgent.indexOf( 'Mobi' ) > -1;
}
/**
 * Return doceree bidder config if it is enabled from backend
 * We have another option to enter Ids for desktop when IDs need to be different on desktop.
 * So, when this option contains a value, send this(docereeTagDesktop) to Prebid on desktop.
 * @param adDiv
 * @returns {*[]}
 */
function getDocereeBidderConfig( adDiv ) {
	let bids = [];
	let bidder = 'docereeadmanager'; // the new doceree adpater
	if( typeof docereeAds === 'undefined' ) { // the plan is to activate the new doceree site by site, so we still need to support the old doceree.
		bidder = 'doceree';
	}
	if ( headerBiddingData['ad_parteners'].indexOf( 'doceree' ) > -1 ) {
		let adUnitID =  window.hmUtils && !window.hmUtils.isMobile() && adDiv.dataset.docereeTagDesktop ? adDiv.dataset.docereeTagDesktop :
			adDiv.dataset.docereeTag;
		if ( adDiv && adUnitID ) {
			bids.push( {
				bidder: bidder,
				params: {
					placementId: adUnitID,
					publisherUrl: document.URL || window.location.href,
				}
			} );
		}
	}
	return bids;
}
/**
 * Return Pulsepoint bidder config if it is enabled from backend
 * @param adDiv
 * @returns {*[]}
 */
function getPulsePointBidderConfig( adDiv, adSize ) {
	let bids = [];
	if ( headerBiddingData['ad_parteners'].indexOf( 'pulsepoint' ) > -1 ) {
		if ( adDiv && adDiv.dataset.pulsepointTag ) {
			if( adSize.length && Array.isArray( adSize[0] ) ) {
				adSize = adSize.map( function( item ){ return item.join( 'x' ); } );
				adSize = adSize.join( ',' );
			} else {
				adSize = adSize.join( 'x' );
			}
			bids.push( {
				bidder: 'pulsepoint',
				params: {
					cf: adSize,
					ct: parseInt( adDiv.dataset.pulsepointTag ),
					cp: 561393
				}
			} );
		}
	}
	return bids;
}

/**
 * Return deepintent bidder config if it is enabled from backend
 * @param adDiv
 * @returns {*[]}
 */
function getDeepIntentBidderConfig( adDiv ) {
	let bids = [];
	if ( headerBiddingData['ad_parteners'].indexOf( 'deepintent' ) > -1 ) {
		if ( adDiv && adDiv.dataset.deepintentTag ) {
			bids.push( {
				bidder: 'deepintent',
				params: {
					tagId: adDiv.dataset.deepintentTag
				}
			} );
		}
	}
	return bids;
}
/**
 * Helper function to sort through defined slots array and get the matching ad slot.
 * @param target
 * @returns {*|*[]}
 */
function getDefinedAdSlot( target ){
	let dfpAdSlots = googletag.pubads().getSlots();
	let matchedSlot = dfpAdSlots.filter( function ( value ) {
		if ( target && target.id === value.getSlotElementId() ) {
			return value;
		}
	} );
	return matchedSlot? matchedSlot : [];
}
/**
 * Set doceree bidder config by collecting visitor's email or NPI, only if it is enabled
 */
function docereePrebidSettings() {
	let npiCookie = window.Cookies && window.Cookies.get( 'hmNpiId' ), userData, hashedemail;
	if( typeof hmUtils !== 'undefined' ) {
		userData = hmUtils.getUserData();
		hashedemail = userData && hmUtils.getHashedEmail();
	}
	let subscriberData = userData && userData.subscriber;
	let medicalData = userData && userData.medicalData;
	let specialty = medicalData && medicalData.specialty ? medicalData.specialty.name : '';
	let address = userData && userData.address;
	const docereeData = {
		email: subscriberData ? subscriberData.email : '',
		firstname: subscriberData ? subscriberData.firstName : '',
		lastname: subscriberData ? subscriberData.lastName : '',
		hcpid: npiCookie ? npiCookie : '',
		state: address ? address.stateCode : '',
		country: address ? address.countryCode : '',
		hashedhcpid: hashedNPI ? hashedNPI : '',
		hashedemail: hashedemail ? hashedemail : '',
		userid: subscriberData ? subscriberData.subscriberId : '',
		platformUid: typeof getCuratorId !== 'undefined' ? getCuratorId() : '', // eslint-disable-line
		specialization: specialty
	};
	// config for the new doceree script
	let docereeConfig = {
		bidders: ['docereeadmanager'],
		config: {
			docereeadmanager: {
				user: {
					data: docereeData
				}
			}
		}
	};// the plan is to activate the new doceree site by site, so we still need to support the old doceree.
	if( typeof docereeAds === 'undefined' ) {
		docereeConfig = {
			bidders:  ['doceree'],
			config: {
				doceree: {
					context: {
						data: {
						}
					},
					user: {
						data: {
							hashedEmail: typeof hmUtils !== 'undefined' && hmUtils.getHashedEmail ? hmUtils.getHashedEmail() : '',
							hashedNPI: hashedNPI,
							platformUid: typeof getPlatformUid !== 'undefined' ? getPlatformUid() : '', // eslint-disable-line
							specialization: specialty
						}
					}
				}
			}
		};
	}
	pbjs.setBidderConfig( docereeConfig );
	return true;
}
/**
 * Default Prebid settings.
 * If hb_deepintent_identity_pixel is set under dashboard settings, pass its related config.
 * @returns {{priceGranularity: {buckets: [{max: number, increment: number}]}, userSync: {filterSettings: {iframe: {bidders: string, filter: string}}}}}
 */
function initPrebidSettings() {
	const prebidConfig = {
		priceGranularity: {
			'buckets': [{
				'max': 5000,
				'increment': 10
			}]
		},
		userSync: {
			filterSettings: {
				iframe: {
					bidders: '*',      // '*' represents all bidders
					filter: 'include'
				}
			}
		},
		enableTIDs : true
	};
	if ( headerBiddingData.hb_deepintent_identity_pixel ) { //Configuration needed for DPES User ID //
		prebidConfig['userSync']['userIds'] = [{
			name: 'deepintentId',
			storage: {
				type: 'html5',
				name: '_dpes_id',
				expires: 90
			}
		}];
		prebidConfig['userSync']['auctionDelay'] = 50;
	}
	return prebidConfig;
}
/**************
 * common function to loop through object and add settargeting parameters
 * */
function adSetTargeting( values, _this ) {
	for ( var key in values ) {
		if ( Object.prototype.hasOwnProperty.call( values, key ) ) {
			_this.setTargeting( key, values[key] );
		}
	}
}
/**
 * Return Lasso bidder config if it is enabled from backend
 * We have another option to enter Ids for desktop when IDs need to be different on desktop.
 * So, when this option contains a value, send this(lassoTagDesktop) to Prebid on desktop.
 * @param adDiv
 * @returns {*[]}
 */
function getLassoBidderConfig( adDiv ) {
	let bids = [];
	if ( headerBiddingData['ad_parteners'].indexOf( 'lasso' ) > -1 ) {
		let adUnitID =  window.hmUtils && !window.hmUtils.isMobile() && adDiv.dataset.lassoTagDesktop ? adDiv.dataset.lassoTagDesktop :
			adDiv.dataset.lassoTag;
		if ( adDiv && adUnitID ) {
			bids.push( {
				bidder: 'lasso',
				params: {
					adUnitId: adUnitID
				}
			} );
		}
	}
	return bids;
}
/**
 * For Prebid 7+ version we need to explicitly pass the below settings for lasso.
 */
function lassoPrebidSettings() {
	pbjs.bidderSettings = {
		lasso: {
			storageAllowed: true
		}
	};
}

/**
 * Get sizes of an ad slot based on the viewport
 * @param adDiv
 * @returns {any}
 */
function getAdSlotDeviceSizes( adDiv ) {
	let responsiveSizes = adDiv.dataset.adResponsiveSizes ? JSON.parse( adDiv.dataset.adResponsiveSizes ) : '';
	let dfpAdSize = responsiveSizes ? isMobile() ? responsiveSizes['mobile'] : responsiveSizes['desktop'] : '';
	return dfpAdSize;
}

/**
 * Return Ogury bidder config if it is enabled from backend
 * We have another option to enter Ids for desktop when IDs need to be different on desktop.
 * So, when this option contains a value, send this(oguryTagDesktop) to Prebid on desktop.
 * @param adDiv
 * @returns {*[]}
 */
function getOguryBidderConfig( adDiv ) {
	let bids = [];
	if ( headerBiddingData['ad_parteners'].indexOf( 'ogury' ) > -1 ) {
		let adUnitID =  window.hmUtils && !window.hmUtils.isMobile() && adDiv.dataset.oguryTagDesktop ? adDiv.dataset.oguryTagDesktop :
			adDiv.dataset.oguryTag;
		if ( adDiv && adUnitID ) {
			bids.push( {
				bidder: 'ogury',
				params: {
					adUnitId: adUnitID,
					assetKey: window.headerBiddingData && window.headerBiddingData.hb_ogury_asset_key
				}
			} );
		}
	}
	return bids;
}

function sendDataToDatalayer( data ) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push( data );
}

function getPulsePointSettings() {
	pbjs.setBidderConfig( {
		bidders: ['pulsepoint'],
		config: {
			ortb2: {
				user: {
					ext: {
						eids: [{ source: location.href, uids: [{ id: hashedNPI }] }]
					}
				}
			}
		}
	} );
}

function userHasOptedInOneTrsut() {
	let userOptedIn = true;
	const OTCookieValue = window.Cookies.get( 'OptanonConsent' );

	if ( OTCookieValue ) {
		if ( OTCookieValue && ( OTCookieValue.includes( 'C0001:0' ) ||
			OTCookieValue.includes( 'C0002:0' ) ||
			OTCookieValue.includes( 'C0003:0' ) ||
			OTCookieValue.includes( 'C0004:0' ) ||
			OTCookieValue.includes( 'C0005:0' ) ) ) {
			userOptedIn = false;
		}
	}
	return userOptedIn;
}

export { dfpAdSlotPath, isMobile, getDocereeBidderConfig, getPulsePointBidderConfig, getDeepIntentBidderConfig,
	getDefinedAdSlot, docereePrebidSettings, initPrebidSettings, adSetTargeting, getLassoBidderConfig, lassoPrebidSettings, getAdSlotDeviceSizes,
	getOguryBidderConfig, getPulsePointSettings, sendDataToDatalayer, userHasOptedInOneTrsut };
